export enum ModalSize {
  Small = 0,
  Medium = 1,
  Large = 2,
  ExtraLarge=3,
  FitContent = 4,
  CustomSignaturePopup = 5,
  CustomConsentPopup = 6
}
